export const optimizedPaintListType = {
    TYPE_PROFILE: 1,
    TYPE_EXPRESS: 2,
    TYPE_ERROR: 3,
    TYPE_PLEATING: 4,
};
